// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { DSNSnapshot } from './types';
import { parseDSNXml } from './utils/parse';

const DSN_URL = 'https://eyes.nasa.gov/dsn/data/dsn.xml';

export async function fetchSnapshot(signal?: AbortSignal): Promise<DSNSnapshot> {
  const cacheBust = `?_=${Date.now()}`;
  const response = await fetch(DSN_URL + cacheBust, { signal, cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`DSN feed returned HTTP ${response.status}`);
  }
  const text = await response.text();
  return parseDSNXml(text);
}
